module.exports = __webpack_public_path__ + "img/900894470.734eda50.png";